<template>
  <v-card density="compact" flat height="90vh" width="100%" class="d-flex flex-column live-board-root">
    <CommonBoardHeader
      :boardName="'Employee Live Board'"
      :existFilterData="existFilterData"
      :workSpaceName="tableData"
      @search-data="getSearch"
      @applyChange="applyChange"
      @export-data="exportFile"
      @show-zero-issue="getSwitchData"
      @scroll="scrollToPosition"
      style="flex-shrink: 0;"
    />

    <!-- Linear progress bar beneath header during data fetching -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="primary"
      height="3"
      style="flex-shrink: 0;"
    ></v-progress-linear>

    <v-card-text class="flex-grow-1 pa-0 overflow-hidden position-relative">
      <!-- Full spinner loader when initial loading or when no data is loaded yet -->
      <div
        v-if="loading && (!tableData || tableData.length === 0)"
        class="d-flex flex-column align-center justify-center"
        style="height: 60vh;"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="52"
          width="4"
        ></v-progress-circular>
        <span class="mt-4 text-grey-darken-2" style="font-size: 15px; font-weight: 500;">
          Loading Employee Live Board...
        </span>
        <span class="text-caption text-grey mt-1">
          Fetching workspaces and employee data
        </span>
      </div>

      <!-- Empty state when not loading and no data found -->
      <div
        v-else-if="!loading && (!tableData || tableData.length === 0)"
        class="d-flex flex-column align-center justify-center"
        style="height: 50vh;"
      >
        <v-icon size="48" color="grey-lighten-1">mdi-account-off-outline</v-icon>
        <span class="mt-3 text-grey-darken-1" style="font-size: 15px; font-weight: 500;">
          No employee records found
        </span>
        <span class="text-caption text-grey mt-1">
          Try clearing filters or adjusting your search
        </span>
      </div>

      <!-- Main Live Table Container -->
      <div
        v-else
        class="table-scroll-container"
        :style="{ opacity: loading ? 0.6 : 1, transition: 'opacity 0.2s ease' }"
        style="width: 100%; height: 100%; overflow: auto;"
      >
        <LiveTable
          :tableData="backupTableData"
          :allData="ProductionData"
          @printData="addData"
          :shift="shift"
          @shiftData="shift = false"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import LiveTable from "./LiveTable.vue";
import ProductionDashboardService from "@/api/service/ProductionDashboard/ProductionDashboard";
import ExportService from "@/ExportService";
import IssueService from "@/api/service/Issue/IssueService";
import CommonBoardHeader from "./CommonBoardHeader.vue";

export default {
  components: {
    LiveTable,
    CommonBoardHeader,
  },

  data() {
    return {
      existFilterData: null,
      menu: false,
      loading: true,
      downloadMenu: ["Excel", "Pdf", "Json"],
      ProductionData: [],
      search: null,
      searchClicked: false,
      tableData: [],
      finalExportData: [],
      backupTableData: [],
      isDrawer: false,
      switchBtn: "OFF",
      workTimingId: null,
      fixedIndex: null,
      shift: false,
    };
  },

  async created() {
    let saved = localStorage.getItem("filterData");
    let filterObj = null;
    if (saved && saved !== "undefined" && saved !== "null") {
      try {
        filterObj = JSON.parse(saved);
        this.existFilterData = filterObj;
      } catch (e) {
        this.existFilterData = null;
      }
    }
    await this.getProductionData(filterObj);
    this.finalExportData = this.tableData;
  },
  computed: {
    isDrawerOpen() {
      return this.$store.getters.getIssueViewDrawer;
    },
    isIssueChanged() {
      return this.$store.getters.getDefaultIssueInView;
    },
  },
  watch: {
    isIssueChanged() {
      this.showIssueView = true;
    },
  },
  methods: {
    scrollToPosition(index) {
      if (index === null || index === undefined) {
        this.fixedIndex = null;
        if (this.switchBtn && this.switchBtn !== "OFF") {
          this.getSwitchData(true);
        } else {
          this.backupTableData = [...this.tableData];
        }
        this.shift = true;
        return;
      }
      this.fixedIndex = index;
      if (this.tableData && this.tableData[this.fixedIndex]) {
        let spliceData = [this.tableData[this.fixedIndex]];
        let switchData = [];
        if (this.switchBtn && this.switchBtn !== "OFF") {
          for (let item of spliceData) {
            let $userData = [];
            for (let item1 of item.userData || []) {
              if (item1.total_issues === 0) {
                $userData.push(item1);
              }
            }
            if ($userData.length > 0) {
              let data = JSON.parse(JSON.stringify(item));
              data.userData = $userData;
              switchData.push(data);
            }
          }
          this.backupTableData = switchData;
        } else {
          this.backupTableData = JSON.parse(JSON.stringify(spliceData));
        }
        this.shift = true;
      }
    },
    applyChange($event) {
      this.fixedIndex = null;
      this.existFilterData = $event;
      this.getProductionData($event);
    },
    async getFilterData(data) {
      this.filterData = data;
      this.filterDialog = false;
      this.getissuetype(this.filterData);
      this.menu = false;
    },
    async getissuetype($obj) {
      let obj = {};
      if ($obj) {
        obj = $obj;
      }
      obj.next_action = this.userId;
      var res = await IssueService.getAssignToMeData(obj);
      this.issueType = res && res.length ? res : [];
    },
    getSwitchData($event) {
      let switchData = [];      
      if ($event) {
        for (let item of this.tableData) {
        let $userData = [];
        for (let item1 of item.userData) {
          if (item1.total_issues === 0) {
            $userData.push(item1);
          }
        }
        if ($userData.length > 0) {
          let data = JSON.parse(JSON.stringify(item));
          data.userData = $userData;
          switchData.push(data);
        }
      }
        this.backupTableData = switchData;
      } else {
        this.backupTableData = [...this.tableData];
      }
      this.shift=true;
    },
    goIssueView(item) {
      let status = this.$store.getters.getMyspace;

      localStorage.setItem(
        "_WS_DEFAULTS_",
        JSON.stringify({
          workspace: { id: item.work_space_id, name: item.work_space_name },
        })
      );
      localStorage.setItem("workSpaceId", item.work_space_id);

      // this.$router.push({ path: "/issueView2", query: { id: item.id } });
      this.$store.dispatch("setIssueInView", item.id);
      let wsDefaults = {
        workspace: { id: item.work_space_id, name: item.work_space_name },
        account: { id: item.account_id, name: item.account_name },
        project: { id: item.project_id, name: item.project_name },
      };
      let wsDefaultsData = JSON.stringify(wsDefaults);
      localStorage.setItem("_WS_DEFAULTS_", wsDefaultsData);
      this.$store.commit("SET_REFRESH_BREADCRUMP", true);
      this.$store.commit("CHANGE_MY_SPACE", !status);
    },
    toggleSearch() {
      this.searchClicked = !this.searchClicked;
      if (this.searchClicked) {
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    handleOutsideClick(event) {
      const textField = this.$refs.searchContainer;
      if (textField && !textField.contains(event.target)) {
        this.searchClicked = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    getSearch($event) {
      let searchData = [];
      if($event.length>0){
      for (let item of this.tableData) {
        let $userData = [];
        for (let user of item.userData) {
          if (
            user &&
            user.userName &&
            user.userName.toLowerCase().includes($event.toLowerCase())
          ) {
            $userData.push(user);
          }
        }
        if ($userData.length > 0) {
          let data = JSON.parse(JSON.stringify(item));
          data.userData = $userData;
          searchData.push(data);
        }
        this.backupTableData = searchData;
      }
    }else{
       this.backupTableData= JSON.parse(JSON.stringify(this.tableData));
    }
    this.shift=true;
    },
    async getProductionData(filterData) {
      this.loading = true;
      try {
        let $obj = {};
        $obj.type = "employee";
        $obj.filterData = filterData ? filterData : null;
        let res = await ProductionDashboardService.liveBoard($obj);
        if (res && res.length > 0) {
          for (let item of res) {
            if (item.userData) {
              item.userData.forEach((item1) => {
                item1.userName =
                  item1 && item1.userName === null ? "" : item1.userName;
              });
              item.userData.sort((a, b) =>
                (a.userName || "").localeCompare(b.userName || "")
              );
              for (let item2 of item.userData) {
                if (item2.accountData) {
                  item2.accountData.sort((a, b) =>
                    (a.account_name || "").localeCompare(b.account_name || "")
                  );
                }
              }
            }
          }
          this.tableData = res;
        } else {
          this.tableData = [];
        }
        this.backupTableData = JSON.parse(JSON.stringify(this.tableData));
      } catch (err) {
        console.error("Error fetching Employee LiveBoard data:", err);
        this.tableData = [];
        this.backupTableData = [];
      } finally {
        this.loading = false;
        this.shift = true;
      }
    },

    addData(data) {
      this.finalExportData = data;
    },

    async exportFile(type) {
      let sourceData = [];
      let column;
      this.finalExportData.forEach((workspace) => {
        workspace.userData.forEach((user) => {
          user.work_space_name = workspace.workSpaceName
          sourceData.push(user)
        });
      });

      column = [
        {
          field: "work_space_name",
          header: "WorkSpace",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },
        {
          field: "userName",
          header: "User",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        },
        
        {
          field: "total_issues",
          header: "Total",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },        
        {
          field: "open_issues",
          header: "Open",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "assigned_issues",
          header: "Assigned",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        
        {
          field: "inprogress_issues",
          header: "Inprogress",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        
        {
          field: "qapending_issues",
          header: "Qa pending",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "clarification_issues",
          header: "Clarification",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "hold_issues",
          header: "Hold",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "it_issues",
          header: "IT",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        {
          field: "pastdue_issues",
          header: "Past Due",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
        // {
        //   field: "qacompleted_issues",
        //   header: "Qa completed",
        //   style: { width: "100px", color: "" },
        //   toolTip: "Num",
        //   sortfield: true,
        // },
        {
          field: "completed_issues",
          header: "Completed/Today",
          style: { width: "100px", color: "" },
          toolTip: "Num",
          sortfield: true,
        },
      ];

      if (this.finalExportData !== this.tableData) {
        column.splice(2, 0, {
          field: "user",
          header: "User",
          style: { width: "100px", color: "" },
          toolTip: "Name",
          sortfield: true,
        });
      }

      await ExportService.export(sourceData, "Live Board", column, type);
    },
  },
};
</script>

<style></style>
